/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EditItemDialog from "./EditItemDialog.vue";

const __vue_script__ = {
  name: "ItemTable",
  components: { EditItemDialog },
  props: ["items", "reasons", "remarksReqd"],
  emits: ["item-change"],
  data() {
    return {
      selectedItem: null,
      list: [],
    };
  },
  mounted() {
    this.list = this.items;
  },
  computed: {},
  methods: {
    onCompletedChange(evt, name) {
      const checked = evt.target.checked;
      const value = checked ? 1 : 0;

      this.$emit("item-change", { name, field: "completed", value });
    },
    onReasonChange(evt, name) {
      const value = evt.target.value;

      this.$emit("item-change", { name, field: "reject_reason", value });
    },
    onEditItem(item) {
      this.selectedItem = item;
    },
    onQtySet(payload) {
      const name = this.selectedItem.name;
      this.selectedItem.completed_qty = payload.qty;
      this.selectedItem.reject_reason = payload.reason;
      this.selectedItem.remarks = payload.remarks;
      this.$emit("item-change", {
        name,
        field: "completed_qty",
        value: payload.qty,
      });
      this.$emit("item-change", {
        name,
        field: "reject_reason",
        value: payload.reason,
      });
      this.$emit("item-change", {
        name,
        field: "remarks",
        value: payload.remarks,
      });
      this.selectedItem = null;
    },
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "list-group" },
        _vm._l(_vm.list, function(item, index) {
          return _c(
            "button",
            {
              key: item.name,
              staticClass: "list-group-item list-group-item-action",
              attrs: {
                type: "button",
                "data-toggle": "modal",
                "data-target": "#editItemDialog"
              },
              on: {
                click: function($event) {
                  return _vm.onEditItem(item)
                }
              }
            },
            [
              _c("div", { staticClass: "item-header" }, [
                _c("small", [_vm._v(_vm._s(item.item_code))]),
                _vm._v(" "),
                _c("h5", [_vm._v(_vm._s(item.item_name))])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex w-100 justify-content-between align-items-center"
                },
                [
                  _c("div", [
                    _c("p", { staticClass: "mb-0 small" }, [
                      _vm._v("Completed Qty:")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-2" }, [
                      _c("strong", [_vm._v(" " + _vm._s(item.completed_qty))]),
                      _vm._v(" / " + _vm._s(item.qty) + "\n            "),
                      _c("small", [_vm._v(_vm._s(item.uom))])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0 small" }, [
                      _vm._v("Reject Reason:")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-2" }, [
                      _c("strong", [_vm._v(_vm._s(item.reject_reason || "-"))])
                    ]),
                    _vm._v(" "),
                    _vm.remarksReqd
                      ? _c("p", { staticClass: "mb-0 small" }, [
                          _vm._v("Remarks:")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.remarksReqd
                      ? _c("p", { staticClass: "mb-2" }, [
                          _c("strong", [_vm._v(_vm._s(item.remarks || "-"))])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [
                      _c("span", { staticClass: "display-4" }, [
                        _vm._v(_vm._s(item.qty))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.uom))])
                    ])
                  ])
                ]
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("edit-item-dialog", {
        attrs: {
          reasons: _vm.reasons,
          item: _vm.selectedItem,
          remarksReqd: _vm.remarksReqd
        },
        on: { set: _vm.onQtySet }
      })
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-738fa4b8_0", { source: "\n.item-header small[data-v-738fa4b8],\nlabel > small[data-v-738fa4b8] {\n  font-weight: bold;\n}\n", map: {"version":3,"sources":["../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/ItemTable.vue"],"names":[],"mappings":";AA6GA;;EAEA,iBAAA;AACA","file":"ItemTable.vue","sourcesContent":["<template>\n  <div>\n    <div class=\"list-group\">\n      <button\n        type=\"button\"\n        class=\"list-group-item list-group-item-action\"\n        data-toggle=\"modal\"\n        data-target=\"#editItemDialog\"\n        v-for=\"(item, index) in list\"\n        :key=\"item.name\"\n        @click=\"onEditItem(item)\"\n      >\n        <div class=\"item-header\">\n          <small>{{ item.item_code }}</small>\n          <h5>{{ item.item_name }}</h5>\n        </div>\n        <div class=\"d-flex w-100 justify-content-between align-items-center\">\n          <div>\n            <p class=\"mb-0 small\">Completed Qty:</p>\n            <p class=\"mb-2\">\n              <strong> {{ item.completed_qty }}</strong> / {{ item.qty }}\n              <small>{{ item.uom }}</small>\n            </p>\n            <p class=\"mb-0 small\">Reject Reason:</p>\n            <p class=\"mb-2\">\n              <strong>{{ item.reject_reason || \"-\" }}</strong>\n            </p>\n            <p class=\"mb-0 small\" v-if=\"remarksReqd\">Remarks:</p>\n            <p class=\"mb-2\" v-if=\"remarksReqd\">\n              <strong>{{ item.remarks || \"-\" }}</strong>\n            </p>\n          </div>\n          <div>\n            <p>\n              <span class=\"display-4\">{{ item.qty }}</span>\n              <span>{{ item.uom }}</span>\n            </p>\n          </div>\n        </div>\n      </button>\n    </div>\n    <edit-item-dialog\n      :reasons=\"reasons\"\n      :item=\"selectedItem\"\n      @set=\"onQtySet\"\n      :remarksReqd=\"remarksReqd\"\n    />\n  </div>\n</template>\n<script>\nimport EditItemDialog from \"./EditItemDialog.vue\";\n\nexport default {\n  name: \"ItemTable\",\n  components: { EditItemDialog },\n  props: [\"items\", \"reasons\", \"remarksReqd\"],\n  emits: [\"item-change\"],\n  data() {\n    return {\n      selectedItem: null,\n      list: [],\n    };\n  },\n  mounted() {\n    this.list = this.items;\n  },\n  computed: {},\n  methods: {\n    onCompletedChange(evt, name) {\n      const checked = evt.target.checked;\n      const value = checked ? 1 : 0;\n\n      this.$emit(\"item-change\", { name, field: \"completed\", value });\n    },\n    onReasonChange(evt, name) {\n      const value = evt.target.value;\n\n      this.$emit(\"item-change\", { name, field: \"reject_reason\", value });\n    },\n    onEditItem(item) {\n      this.selectedItem = item;\n    },\n    onQtySet(payload) {\n      const name = this.selectedItem.name;\n      this.selectedItem.completed_qty = payload.qty;\n      this.selectedItem.reject_reason = payload.reason;\n      this.selectedItem.remarks = payload.remarks;\n      this.$emit(\"item-change\", {\n        name,\n        field: \"completed_qty\",\n        value: payload.qty,\n      });\n      this.$emit(\"item-change\", {\n        name,\n        field: \"reject_reason\",\n        value: payload.reason,\n      });\n      this.$emit(\"item-change\", {\n        name,\n        field: \"remarks\",\n        value: payload.remarks,\n      });\n      this.selectedItem = null;\n    },\n  },\n};\n</script>\n\n<style scoped>\n.item-header small,\nlabel > small {\n  font-weight: bold;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-738fa4b8"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/ItemTable.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__